import {IconButton, TableCell, TableRow, TextField, Tooltip} from "@mui/material";
import {amber} from "@mui/material/colors";
import {HugeiconsIcon} from "@hugeicons/react";
import {Delete02Icon} from "@hugeicons/core-free-icons";

export const PhoneNumberRow = ({row, index, duplicate, empty, onChange, onDelete}) => {
  return (
    <TableRow sx={{bgcolor: duplicate ? amber[100] : undefined}}>
      <TableCell sx={{fontSize: 12}}>{index}</TableCell>
      <TableCell>
        <TextField
          variant="standard" fullWidth size="small"
          value={row.value}
          onChange={(e) => onChange(row.id, e.target.value)}
          error={empty}
          helperText={duplicate ? "Duplicate number" : empty ? "Empty number" : undefined}
          FormHelperTextProps={{sx: {color: duplicate ? amber[900] : undefined}}}
        />
      </TableCell>
      <TableCell padding="checkbox">
        <Tooltip title="Remove">
          <IconButton size="small" onClick={() => onDelete(row.id)}>
            <HugeiconsIcon icon={Delete02Icon} size={16}/>
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}
